import { Container } from "@remo-co/ui-core/src/components/Container";
import { selectCompanyId } from "modules/company/redux/selectors";
import CreateDirectoryButton from "modules/eventDirectory/components/CreateDirectoryButton";
import { CreateEventButton } from "modules/eventForm/components";
import { useSelector } from "react-redux";
import { selectCustomDomainCompanyID } from "modules/settings/redux/selectors";
import { selectIsAnonymousUser } from "modules/auth/redux/selectors";
import { StartFreeTrialCard } from "../StartFreeTrialCard";
import { CreateFirstEventCard } from "../CreateFirstEventCard";

interface Props {
  isLoading: boolean;
  noOfEvents: number;
  isEventHelper: boolean;
}

export const MyEventsHeader = ({
  isLoading,
  noOfEvents,
  isEventHelper,
}: Props) => {
  const companyId = useSelector(selectCompanyId);
  const customDomainCompanyID = useSelector(selectCustomDomainCompanyID);
  const isUserAnonymous = useSelector(selectIsAnonymousUser);

  if (isEventHelper || isLoading || isUserAnonymous) {
    return null;
  }

  if (!companyId && !customDomainCompanyID) {
    return (
      <Container top="xl" bottom="lg">
        <StartFreeTrialCard />
      </Container>
    );
  }

  if (!companyId && customDomainCompanyID) {
    return null;
  }

  return noOfEvents > 0 ? (
    <Container flex justifyContent="flex-start">
      <CreateEventButton size="md" id="my-event_primary-cta-create-event" />
      <CreateDirectoryButton />
    </Container>
  ) : (
    <Container top="xl" bottom="lg">
      <CreateFirstEventCard />
    </Container>
  );
};
